/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useRef } from 'react';
import PropTypes from 'prop-types';
import ReactPasswordToggleIcon from 'react-password-toggle-icon';
import FeatherIcon from 'feather-icons-react';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { DatePicker, Select, Spin, TimePicker } from 'antd';
import { dateFormatList } from '../../utils/Data';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import dayjs from 'dayjs';
import './input.css';

function safeArray(arr) {
  return Array.isArray(arr) ? arr : [];
}

export const InputFromUser = props => {
  const {
    touched = false,
    disabled = false,
    label = '',
    name = '',
    value = '',
    onChange = () => { },
    disabledDate,
    onSearch,
    onSearchLoading = false,
    dropdownRender,
    onBlur = () => { },
    FormGroupClassName = '',
    error = '',
    FormControlClassName = '',
    LabelClassName = '',
    InputConatiner = '',
    placeholder = '',
    placement = '',
    Dropdown_ClassName = '',
    type = 'text',
    ShowRightIcon = false,
    options = [],
    ComponentStyle = {},
    selectedValue = '',
    max = undefined,
  } = props;
  let inputRef = useRef();
  const showIcon = () => (
    <i className="feather feather-eye">
      <FeatherIcon icon="eye" />
    </i>
  );
  const hideIcon = () => (
    <i className="feather feather-eye-slash">
      <FeatherIcon icon="eye-off" />
    </i>
  );
  const IsInputText =
    type === 'text' ||
    type === 'color' ||
    type === 'email' ||
    type === 'number' ||
    type === 'password' ||
    type === 'search' ||
    type === 'url' ||
    type === 'tel';
  const IsTextArea = type === 'textarea';
  const ShowPassTogleIcon = type === 'password' && IsInputText;
  const ShowDropDown = type === 'multiple' || type === 'singleSelect';
  const ShowRadio = type === 'radio' || type === 'buttonGroup';
  const ShowTimePicker = type === 'TimePicker';
  return (
    <>
      <div className={`form-group ${FormGroupClassName}`}>
        <label style={{ color: error && touched && 'red' }} className={LabelClassName}>
          {label}
          {error && <span className="login-danger"> *</span>}
        </label>
        <div
          className={`${InputConatiner} ${ShowRadio && 'form-control d-flex justify-content-between'}`}
          style={{ borderColor: error && touched && 'red', borderWidth: 1 }}
        >
          {IsInputText && (
            <input
              ref={inputRef}
              className={`pass-input form-control ${error && touched ? 'error' : ''}${FormControlClassName}`}
              placeholder={placeholder}
              aria-describedby="sizing-addon3"
              type={type}
              style={{ borderColor: error && touched && 'red', borderWidth: 1 }}
              name={name}
              disabled={disabled}
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              max={type === 'number' ? max : undefined}
            />
          )}

          {IsTextArea && (
            <textarea
              ref={inputRef}
              className={`pass-input form-control ${error && touched ? 'error' : ''}${FormControlClassName}`}
              placeholder={placeholder}
              name={name}
              disabled={disabled}
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              rows={10}
              style={{ borderColor: error && touched && 'red', borderWidth: 1, minHeight: '80px' }}
            />
          )}

          {ShowPassTogleIcon && (
            <ReactPasswordToggleIcon inputRef={inputRef} showIcon={showIcon} hideIcon={hideIcon} />
          )}

          {ShowDropDown && (
            <Select
              showSearch
              style={{
                height: 43,
                width: '100%',
                flex: 1,
                ...ComponentStyle,
              }}
              disabled={disabled}
              className={Dropdown_ClassName}
              mode={type === 'multiple' ? 'multiple' : type === 'tags' ? 'tags' : undefined}
              maxTagCount={'responsive'}
              value={value || undefined}
              optionFilterProp="children"
              onChange={onChange}
              onBlur={onBlur}
              dropdownRender={dropdownRender}
              onSearch={onSearch}
              filterOption={
                onSearch
                  ? false
                  : (input, option) =>
                    (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
              }
              placement={placement}
              notFoundContent={onSearchLoading ? <Spin size="small" /> : null}
              status={error && touched && 'error'}
              placeholder={placeholder}
              listHeight={256}
              dropdownStyle={{
                maxWidth: '100vw',
                minWidth: '250px',
              }}
              popupClassName="custom-select-dropdown"
              options={safeArray(options)
                .filter(item => {
                  const label = item?.label || item;
                  const val = item?.value || item;
                  return label && val && label.toString().trim() !== "" && val.toString().trim() !== "";
                })
                .map(item => ({
                  label: item?.label || item,
                  value: item?.value || item,
                }))
                .sort((a, b) => {
                  try {
                    // For multiple select mode, check if value is an array
                    const isSelected = itemValue => {
                      try {
                        if (Array.isArray(value)) {
                          return value.includes(itemValue);
                        }
                        return value === itemValue;
                      } catch (err) {
                        return false;
                      }
                    };

                    const aSelected = isSelected(a?.value);
                    const bSelected = isSelected(b?.value);

                    // Move selected items to top
                    if (aSelected && !bSelected) return -1;
                    if (!aSelected && bSelected) return 1;
                    return 0;
                  } catch (err) {
                    return 0;
                  }
                })}
            />
          )}

          {ShowRadio &&
            safeArray(options)
              .filter(item => {
                const label = item?.label || item;
                const val = item?.value || item;
                return label && val && label.toString().trim() !== "" && val.toString().trim() !== "";
              })
              .map((option, index) => (
                <div className="radio col-xl col-md" key={index}>
                  <label>
                    <input
                      type="radio"
                      name={name}
                      disabled={disabled}
                      value={option?.value || option}
                      checked={selectedValue === (option?.value || option)}
                      onChange={() => onChange(option?.value || option)}
                      onBlur={onBlur}
                    />{' '}
                    {option?.label || option}
                  </label>
                </div>
              ))}
          {type === 'date' && (
            <DatePicker
              className="d-flex p-2"
              status={error && touched && 'error'}
              value={value ? dayjs(value) : null}
              picker="date"
              format={dateFormatList}
              placement={placement}
              disabled={disabled}
              disabledDate={disabledDate}
              placeholder={placeholder}
              onChange={(date) => {
                const dateString = date ? date.format('YYYY-MM-DD') : null;
                onChange(dateString);
              }}
              size="large"
              onBlur={onBlur}
            />
          )}
          {ShowTimePicker && (
            <TimePicker
              className="d-flex p-2"
              status={error && touched && 'error'}
              value={value && dayjs.isDayjs(value) ? value : (value ? dayjs(value, 'h:mm a') : null)}
              placeholder={placeholder}
              placement={placement}
              onChange={(time) => {
                // Pass the dayjs object directly to onChange
                onChange(time);
              }}
              size="large"
              disabled={disabled}
              onBlur={onBlur}
              minuteStep={15}
              format="h:mm a"
              use12Hours
            />
          )}
        </div>
        {error && touched && !ShowRadio && <div className="text-danger m-1">{error}</div>}
        {ShowRadio && error && touched && <div className="text-danger m-1">{error}</div>}
      </div>
    </>
  );
};

InputFromUser.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.any]),
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  disabledDate: PropTypes.func,
  onSearchLoading: PropTypes.bool,
  onBlur: PropTypes.func,
  error: PropTypes.oneOfType(PropTypes.string, PropTypes.object),
  FormGroupClassName: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  placement: PropTypes.string,
  dropdownRender: PropTypes.func,
  InputConatiner: PropTypes.string,
  LabelClassName: PropTypes.string,
  FormControlClassName: PropTypes.string,
  Dropdown_ClassName: PropTypes.string,
  touched: PropTypes.oneOfType(PropTypes.string, PropTypes.bool),
  disabled: PropTypes.bool,
  ShowRightIcon: PropTypes.bool,
  ComponentStyle: PropTypes.object,
  selectedValue: PropTypes.string,
  options: PropTypes.array,
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export const TextEditor = ({
  onFocus = () => { },
  onChange = () => { },
  onBlur = () => { },
  name = '',
  value = '',
  errorMessage = '',
}) => {
  return (
    <div>
      <CKEditor
        editor={ClassicEditor}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        data={value}
      />
      {errorMessage && <div style={{ color: '#DC3545' }}>{errorMessage}</div>}
    </div>
  );
};

TextEditor.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  onFocus: PropTypes.func,
  name: PropTypes.func,
  errorMessage: PropTypes.string,
};
